module.exports = __webpack_public_path__ + "static/media/whatsapp.8793de80.svg";